<!-- Message -->
<p-toast>
	<ng-template let-message pTemplate="message">
		<div class="p-grid p-ml-2">
			<div class="p-col-2">
				<i class="pi pi-exclamation-triangle" style="font-size: 2rem"></i>
			</div>
			<div class="p-col-10">
				<h4>{{message.summary}}</h4>
			</div>
			<div class="p-col-12">
				<p>{{message.detail}}</p>
			</div>
			<div *ngIf="message.severity!='success'" class="p-col-12">
				<a class="p-button"
					href="mailto:{{env_supportmail}}?subject=Fehlermeldung%20VION&amp;body={{message.summary}}%0A%0A{{message.detail}}%0D%0A%0D%0AName:%0D%0AEmail:%0D%0ATelefon:%0D%0AKommentar:%0D%0A%0D%0A%0D%0AZum%20besseren%20Verständnis%20wenn%20möglich%20bitte%20Screenshots%20beifügen.">
					Fehler melden
				</a>
			</div>
		</div>
	</ng-template>
</p-toast>

<!-- Spinner -->
<div *ngIf="loading!==0" class="spinner">
	<span class="ball-1"></span>
	<span class="ball-2"></span>
	<span class="ball-3"></span>
	<span class="ball-4"></span>
	<span class="ball-5"></span>
	<span class="ball-6"></span>
	<span class="ball-7"></span>
	<span class="ball-8"></span>
</div>

<!-- Content -->
<div class="p-grid p-formgrid">
	<div *ngFor="let groupOptions of optionGroups" class="p-col-12 card p-mb-2">
		<div class="p-grid p-formgrid">
			<div *ngFor="let groupOption of groupOptions | keyvalue: unsorted" class="p-col-12 p-md-6 p-lg-4 p-my-2">
				<!--{{ (field.sub ? ('HEADERS.' + field.sub + '.' + field.key) : ('HEADERS.' + field.key)) | translate }}-->
				<!--<h6 class="p-my-2" translate>{{'HEADERS.' + option.key}}</h6>-->
				<h6 class="p-my-2" translate>{{ (groupOption.value.sub ? ('HEADERS.' + groupOption.value.sub + '.' + groupOption.key) : ('HEADERS.' + groupOption.key)) }}</h6>
				<div *ngIf="groupOption.value.type == 'text'">
					<input type="text" pInputText style="width:100%" [(ngModel)]="selections[groupOption.key]" />
				</div>
				<div *ngIf="groupOption.value.type == 'numeric'">
					<p-inputNumber [style]="{'width':'100%'}" [(ngModel)]="selections[groupOption.key]" [showButtons]="true"
						[min]="groupOption.value.min" [max]="groupOption.value.max" [step]="groupOption.value.step" mode="decimal"
						locale="de-DE"></p-inputNumber>
				</div>
				<div *ngIf="groupOption.value.type == 'boolean'">
					<p-triStateCheckbox [(ngModel)]="selections[groupOption.key]"></p-triStateCheckbox>
				</div>
				<div *ngIf="groupOption.value.type == 'date'">
					<p-calendar [style]="{'width':'100%'}" [showIcon]="true" dateFormat="dd.mm.yy" keepInvalid="true"
						(onInput)="inputDate(groupOption.key, $event.target.value)" appendTo="body"
						[(ngModel)]="selections[groupOption.key]"
						(onSelect)="selections[groupOption.value.timespanFieldName] = null">
					</p-calendar>
				</div>
				<div *ngIf="groupOption.value.type == 'date_noTimespan'">
					<p-calendar [style]="{'width':'100%'}" [showIcon]="true" dateFormat="dd.mm.yy" keepInvalid="true"
						(onInput)="inputDate(groupOption.key, $event.target.value)" appendTo="body"
						[(ngModel)]="selections[groupOption.key]">
					</p-calendar>
				</div>
				<div *ngIf="groupOption.value.type == 'timespan'">
					<p-dropdown [style]="{'width':'100%'}" [options]="groupOption.value.values"
						[(ngModel)]="selections[groupOption.key]" appendTo="body"
						(onChange)="convertTimespanSelection($event, groupOption.value.fromDateFieldName, groupOption.value.toDateFieldName)"
						[filter]="false" [filterBy]="groupOption.value.labelFieldName" placeholder="-" [showClear]="true"
						dropdownDirective></p-dropdown>
				</div>
				<div *ngIf="groupOption.value.type == 'dropdown'">
					<p-dropdown [style]="{'width':'100%'}" [options]="groupOption.value.values" appendTo="body"
						[virtualScroll]="true" itemSize="30" [optionLabel]="groupOption.value.labelFieldName"
						[optionValue]="groupOption.value.valueFieldName" [(ngModel)]="selections[groupOption.key]" [filter]="true"
						[filterBy]="groupOption.value.labelFieldName" placeholder="-" [showClear]="true" dropdownDirective>
					</p-dropdown>
				</div>
				<div *ngIf="groupOption.value.type == 'multiselect'">
					<p-multiSelect [options]="groupOption.value.values" [(ngModel)]="selections[groupOption.key]"
						[optionLabel]="groupOption.value.labelFieldName" [optionValue]="groupOption.value.valueFieldName"
						appendTo="body" placeholder="-" [virtualScroll]="true" itemSize="30" [filter]="true"
						[filterBy]="groupOption.value.labelFieldName" [style]="{'width':'100%'}" multiSelectDirective>
					</p-multiSelect>
				</div>
                <div *ngIf="groupOption.value.type === 'rating'" class="p-formgroup-inline">
                    <div class="p-m-1">
                        <p-dropdown [options]="ratings" [(ngModel)]="selections[groupOption.key]"
                                    [showClear]="true" dropdownDirective>
                            <ng-template let-option pTemplate="selectedItem">
                                <i [ngClass]="option.value === 0 ? 'pi pi-circle-off' : 'pi pi-circle-on'"
                                   [style.color]="option.icon"></i>
                                <!--<i [ngClass]="option.value == null || option.value == undefined ? 'pi pi-circle-off' : 'pi pi-circle-on'"
                                   [style.color]="option.icon"></i>-->
                            </ng-template>
                            <ng-template let-option pTemplate="item">
                                <i [ngClass]="option.value === 0 ? 'pi pi-circle-off' : 'pi pi-circle-on'"
                                   [style.color]="option.icon"></i>
                                <!--<i [ngClass]="option.value == null || option.value == undefined ? 'pi pi-circle-off' : 'pi pi-circle-on'"
                                   [style.color]="option.icon"></i>-->
                            </ng-template>
                        </p-dropdown>
                    </div>
                </div>
			</div>
		</div>
	</div>
	<div *ngIf="commitButtonVisible" class="p-col-12">
		<!--<button pButton pRipple label="{{'BUTTONS.LOAD'|translate}}" class="p-button p-mt-2" style="width:100%"
			(click)="load()"></button>-->
			<button pButton pRipple [label]="commitButtonLabel" class="p-button p-mt-2" style="width:100%"
			(click)="load()"></button>
	</div>
</div>